import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";

/**
 * Clears the reservationOffer URL parameter from the current URL and store
 * This should be called when user makes changes that invalidate the existing offer
 * (e.g., changing dates, accommodation type, or adding new accommodations)
 */
export const clearReservationOfferURLParam = () => {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has(URLParam.ReservationOffer)) {
    urlParams.delete(URLParam.ReservationOffer);
    window.history.replaceState(window.history.state, "", `?${urlParams.toString()}`);

    // Also clear the reservation offer option ID from the store
    useEngineStore.getState().setReservationOfferOptionId(undefined);
  }
};
